module.exports = ".search-form-field {\n  height: 46px;\n}\n"